module.exports = __webpack_public_path__ + "static/media/IndustryLeader006.2a5923dd.png";